import React from 'react';
import { push } from 'connected-react-router';
import { useConversionTeaser } from '~api/hooks/useConversionTeaser';
import { OPEN_URL } from '~constants/cpa-message-codes';
import { useAppDispatch } from '~store';
import { checkIsExternalLink } from '~utils/checkIsExternalLink';
import { getPathWithLanguageCode } from '~utils/languageInURL';
import { useStyles } from './ConversionTeaser.styles';
var BACKGROUND_COLOR = process.env.TEASER_BACKGROUND_COLOR || '';
var duration = 1000;
export var ConversionTeaser = function (_a) {
    var id = _a.id, mediaUrl = _a.mediaUrl, linkUrl = _a.linkUrl;
    var classes = useStyles();
    var dispatch = useAppDispatch();
    var putConversionTeaserClick = useConversionTeaser().putConversionTeaserClick;
    var isWebView = window.isWebView;
    var onTeaserClick = function () {
        if (!linkUrl) {
            return;
        }
        putConversionTeaserClick(id);
        var onExternalLinkClick = function () {
            var _a;
            if (isWebView) {
                (_a = window.ReactNativeWebView) === null || _a === void 0 ? void 0 : _a.postMessage(JSON.stringify({
                    code: OPEN_URL,
                    params: {
                        url: linkUrl,
                    },
                }));
            }
            else {
                window.open(linkUrl, '_blank');
            }
        };
        checkIsExternalLink(linkUrl)
            ? onExternalLinkClick()
            : dispatch(push(getPathWithLanguageCode("".concat(linkUrl))));
    };
    return (React.createElement("div", { className: classes.container, style: { background: BACKGROUND_COLOR } },
        React.createElement("img", { src: mediaUrl, className: classes.fadeIn, style: { animationDuration: "".concat(duration, "ms") }, onClick: onTeaserClick, alt: "teaser" })));
};
